// ES6 version of single_input_modal.js
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';

const KeyboardUtil = require('../../util/keyboard');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    defaultValue: PropTypes.string,
    headerText: PropTypes.string,
    inputLabel: PropTypes.string,
    ariaLabel: PropTypes.string,
    buttonText: PropTypes.string,
    multiline: PropTypes.bool,
    error: PropTypes.object,
    disableButton: PropTypes.bool,
    inputValidationError: PropTypes.bool,
};

const defaultProps = {
    show: false,
    defaultValue: '',
    headerText: '',
    inputLabel: '',
    ariaLabel: '',
    buttonText: 'ok',
    multiline: false,
    error: null,
    disableButton: false,
    inputValidationError: false,
};

class SingleInputModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: props.defaultValue || '',
        };
        this.inputElem = React.createRef();
        this.onChangeInput = this.onChangeInput.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
    }

    componentDidMount() {
        this.focusOnInput();
    }

    onChangeInput(e) {
        e.stopPropagation();
        this.setState({ inputValue: e.target.value });
    }

    submitHandler(e) {
        if (this.props.disableButton) return;

        e.preventDefault(); // prevent page refresh when pressing enter in input box (TODO... WHY?)
        this.props.submitHandler(this.state.inputValue);
    }

    handleKeyDown(e) {
        e.stopPropagation();
        if (!this.props.multiline && KeyboardUtil.isEnterKey(e.keyCode)) {
            this.submitHandler(e);
        }
    }

    focusOnInput() {
        const inputElem = this.inputElem.current;
        if (!inputElem) {
            return;
        }

        inputElem.focus();
        if (!!this.props.defaultValue) {
            inputElem.setSelectionRange(0, inputElem.value.length);
        }
    }

    render() {
        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{this.props.headerText}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.props.error} />
                    <Form>
                        <Form.Group controlId="modal-input">
                            <Form.Label>{this.props.inputLabel}</Form.Label>
                            <Form.Control
                                as={this.props.multiline ? 'textarea' : 'input'}
                                ref={this.inputElem}
                                aria-label={this.props.ariaLabel}
                                value={this.state.inputValue}
                                onChange={this.onChangeInput}
                                onKeyDown={this.handleKeyDown}
                                isInvalid={!!this.props.inputValidationError}
                            />
                        </Form.Group>
                    </Form>
                    {this.props.children}
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={this.props.disableButton} onClick={this.submitHandler}>
                        {this.props.buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

SingleInputModal.propTypes = propTypes;
SingleInputModal.defaultProps = defaultProps;

export default SingleInputModal;